import React, { useState, useEffect, useMemo } from 'react';
import Visa from '/cards/visa-card.svg';
import Amex from '/cards/card-amex.svg';
import Diners from '/cards/card-diners.svg';
import Discover from '/cards/card-discover.svg';
import Elo from '/cards/card-elo.svg';
import Jcb from '/cards/card-jsb.svg';
import Maestro from '/cards/card-maestro.svg';
import Union from '/cards/card-union.svg';

const CreditCards = () => {
	const imagesArray = [Visa, Maestro, Amex, Discover, Diners, Elo, Jcb, Union];
	const [tooltipActive, setTooltipActive] = useState(false);
	const [windowSize, setWindowSize] = useState(window.innerWidth);

	const handleResize = () => {
		setWindowSize(window.innerWidth);
	};

	const visibleCards = useMemo(() => {
		if (windowSize > 1031) {
			return { show: imagesArray.slice(0, 4), hide: imagesArray.slice(4) };
		} else {
			return { show: imagesArray.slice(0, 3), hide: imagesArray.slice(3) };
		}
	}, [windowSize]);

	useEffect(() => {
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	return (
		<div className="cardsContainer">
			{visibleCards.show &&
				visibleCards.show.map((image, index) => {
					return <img key={index} className="cardsContainer__cardImage" src={image} alt={image} />;
				})}
			<div
				className="cardsContainer__cardImage cardsContainer__cardImage--placeholder"
				onClick={() => {
					if (window.isMobile) {
						setTooltipActive(!tooltipActive);
					}
				}}
			>
				+{visibleCards.hide.length}
				<div
					className={`${tooltipActive ? 'tooltip tooltip--active' : 'tooltip'}`}
					visible={tooltipActive.toString()}
				>
					<div className="tooltip__wrapper">
						{visibleCards.hide &&
							visibleCards.hide.map((image, index) => {
								return <img key={index} className="cardsContainer__cardImage" src={image} alt={image} />;
							})}
					</div>
				</div>
			</div>
		</div>
	);
};

export default CreditCards;
